<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="file_040"><strong>7.</strong> Sew black beads onto the front of the bumblebee for eyes.</a></p><a id="file_040">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_040.vue?64bafaa4